import React from 'react'
import { IntlContext } from 'react-intl'
import { invariant } from '@formatjs/ecma402-abstract'

export function invariantIntlContext(intl?: any): asserts intl {
  invariant(
    intl,
    '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.'
  )
}

export default function useFormattedMessage(msg: string, defaultMsg?: string, value?: any) {
  const intl = React.useContext(IntlContext)
  invariantIntlContext(intl)
  return intl.formatMessage({ id: msg, defaultMessage: defaultMsg || msg }, value)
}
